import React from 'react';
import PropTypes from 'prop-types';

class ValidatingField extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.initialState();

    this.validations = [];
    if (this.props.required) {
      this.validations.push(this.validateRequired);
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.validate = this.validate.bind(this);
    this.displayErrors = this.displayErrors.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.resetField) {
      this.setState(this.initialState());
    }
  }

  initialState() {
    return {
      error: null,
      value: this.props.value || '',
      shouldDisplayError: false,
      beenVisited: false,
    }
  }

  newStateFromInput(e) {
    return { value: e.target.value };
  }

  handleChange(e) {
    const state = this.newStateFromInput(e);
    this.setState(state, () => {
      this.validate(() => {
        if (this.state.beenVisited) {
          this.displayErrors();
        }
      });
    });

    this.props.updateModel(this.props.name, this.valueForMinisterUpdate(state.value));

    if (this.props.handleChange) {
      this.props.handleChange(e);
    }
  }

  valueForMinisterUpdate(value) {
    return value;
  }

  handleBlur() {
    this.validate(this.displayErrors);
    this.setState({
      beenVisited: true
    });
  }

  displayErrors() {
    this.props.updateErrorMessage();
    this.setState({
      shouldDisplayError: !!this.state.error,
    });
  }

  validateRequired(value) {
    if (value === '') {
      return `${ this.props.displayName } is required`;
    }
  }

  validate(callback) {
    var error;

    for (var i = 0; i < this.validations.length; i++) {
      const boundValidator = this.validations[i].bind(this);
      error = boundValidator(this.state.value);
      if (!!error) { break; }
    }

    if (!!error) {
      this.props.onError(this.props.name, error);
    } else {
      this.props.onValid(this.props.name);
    }

    this.setState({
      error: error
    }, callback);
  }

  renderInput() {
    throw `${this.constructor.name} does not implement renderInput()`;
  }

  render() {
    return (
      <div className={ this.props.className }>
        { this.renderInput() }
      </div>
    );
  }
}

ValidatingField.propTypes = {
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  resetField: PropTypes.bool,
};

export default ValidatingField;
